import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import { Lock } from './DesignSystem/Icons'

const LockSign = ({ id, text, style, className }) => {
  const theme = useContext(ThemeContext)

  return (
    <div id={id} style={{ ...style }} className={className}>
      <Lock fill={theme.ds_gray_3} width="20px" height="20px" />
      <div className="text">{text}</div>
    </div>
  )
}

export default styled(LockSign)`
  display: flex;

  & > * {
    &:first-of-type {
      margin-right: ${({ margin }) => margin || '6px'};
    }
  }

  .text {
    color: ${({ theme }) => theme.ds_gray_3};
  }
`
